import { openService, SERVICE_TYPE } from '~/utils/qiyukf'
import { useUserStore } from '~/store/common/user'

/**
 * @description 七鱼客服相关能力封装
 * @returns {{ openQiyuChat: (typeOrMeta?: string | Object, kefuInfo?: any[]) => void, SERVICE_TYPE: Object }}
 */
export const useQiyuChat = () => {
  const userStore = useUserStore()

  /**
   * @description 打开七鱼客服聊天窗口
   * @param {string | Object} [typeOrMeta='sales'] - 客服类型或包含类型的对象
   * @param {any[]} [kefuInfo=[]] - 自定义客服透传字段
   * @example
   * const { openQiyuChat, SERVICE_TYPE } = useQiyuChat()
   * openQiyuChat(SERVICE_TYPE.SALES)
   * // 或者兼容旧版对象传参，并透传额外信息
   * openQiyuChat({ type: 'afterSales', from: 'order-detail', orderId: '123' })
   */
  const openQiyuChat = (typeOrMeta = SERVICE_TYPE.SALES, kefuInfo = []) => {
    if (!import.meta.client) return

    let type = SERVICE_TYPE.SALES
    const combinedKefuInfo = [...kefuInfo]

    if (typeof typeOrMeta === 'string') {
      type = typeOrMeta
    } else if (typeof typeOrMeta === 'object' && typeOrMeta !== null) {
      type = typeOrMeta.type || SERVICE_TYPE.SALES
      // 将对象中的其他字段转为 kefuInfo 格式透传给七鱼
      Object.entries(typeOrMeta).forEach(([key, value]) => {
        if (key !== 'type' && value !== undefined && value !== null) {
          // 检查是否已存在同名 key
          if (!combinedKefuInfo.some((item) => item.key === key)) {
            combinedKefuInfo.push({
              key,
              value: String(value),
              label: key,
            })
          }
        }
      })
    }

    // 获取当前登录用户信息
    const userInfo = userStore.isLoggedIn ? userStore.userInfo : null

    // 调用工具类打开客服
    openService(type, userInfo, combinedKefuInfo)
  }

  return {
    openQiyuChat,
    SERVICE_TYPE,
  }
}
